<template>
  <div v-if="currentRoles.name === '属性管理'" class="page-index property-index">
    <div class="toolbar-box">
      <el-button v-if="currentRoles.roles['属性管理-新增']" class="btn-left" size="mini" @click="openModel">添加属性</el-button>
      <div style="flex:1"></div>
      <el-select v-if="userInfo.companyList.length > 0" class="search-input" v-model="companyId" @change="seach" placeholder="请选择公司">
        <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
      </el-select>
      <el-input  class="search-input" size="mini" v-model="query" @keyup.enter.native="seach" placeholder="请输入字段名" />
    </div>
    <el-table
        ref="userTable"
        :data="list"
        stripe
        size="mini"
        empty-text="暂无数据"
        row-class-name="table-row-cursor"
        header-row-class-name="header-row"
        :height="tableHeight"
        :maxHeight="tableHeight"
        style="width: 100%;">
       <el-table-column
          header-align="center"
          align="center"
          type="index"
          :index="indexMethod"
          width="50"
          label="#">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="name"
          label="属性名称">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="100"
          prop="type"
          label="类型">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="values"
          label="属性值">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          prop="remark"
          label="备注">
      </el-table-column>
      <el-table-column
          header-align="center"
          align="center"
          width="120"
          label="操作">
        <template slot-scope="scope">
          <el-tooltip v-if="currentRoles.roles['属性管理-编辑']" content="编辑" placement="top">
            <el-button size="mini" @click.stop="openModel2(scope.row)">
              <i class="icon el-icon-edit"></i>
            </el-button>
          </el-tooltip>
          <el-tooltip v-if="currentRoles.roles['属性管理-删除']" content="删除" placement="top">
            <el-button size="mini" @click.stop="handleDelete(scope.row)">
              <i class="icon el-icon-delete"></i>
            </el-button>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>

    <el-pagination
        :current-page.sync="pageIndex"
        @current-change="pageChange"
        layout="->, total, prev, pager, next"
        :page-size="pageSize"
        :total="total"
        class="pagination">
    </el-pagination>

    <el-dialog
        title="添加属性"
        :visible.sync="dialogVisible"
        width="550px"
        :before-close="handleClose">
      <el-form ref="property" :model="form" label-width="180px">
        <el-form-item label="公司" prop="companyId">
          <el-select class="search-input" v-model="form.companyId" placeholder="请选择公司">
            <el-option v-for="item in userInfo.companyList" :key="item.id" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性名称" prop="name">
          <el-input placeholder="请输入属性名称" v-model="form.name"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="form.type" placeholder="请选择类型">
            <el-option v-for="item in typeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性值">
          <el-input placeholder="请输入属性值" v-model="form.values"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input placeholder="请输入备注" v-model="form.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleAdd">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog
        title="修改属性"
        :visible.sync="dialogVisible2"
        width="550px"
        :before-close="handleClose">
      <el-form ref="property2" :model="form" label-width="180px">
        <el-form-item label="属性名称" prop="name">
          <el-input placeholder="请输入属性名称" v-model="currentRow.name"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="type">
          <el-select v-model="currentRow.type" placeholder="请选择类型">
            <el-option v-for="item in typeList" :key="item.value" :label="item.name" :value="item.value"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="属性值">
          <el-input placeholder="请输入属性值" v-model="currentRow.values"></el-input>
        </el-form-item>
        <el-form-item label="备注">
          <el-input placeholder="请输入备注" v-model="currentRow.remark"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="handleEdit">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script type="text/ecmascript-6">
  import { tableMixin } from '../../mixins/table'
  import { formatDate } from '../../utils/common'
  import { mapGetters } from 'vuex'
  import { apiEdit, apiDelete, apiDetail, apiList } from '../../api/property'

  export default {
    mixins: [tableMixin],
    name: 'property',
    data() {
      return {
        dialogVisible: false,
        dialogVisible2: false,
        list: [],
        pageIndex: 1,
        total: 0,
        companyId: '',
        query: '',
        form: {},
        currentRow: {},
        typeList: [{
          value: 1,
          name: '文本框'
        }, {
          value: 2,
          name: '单选框'
        }, {
          value: 3,
          name: '复选框'
        }],
        rules: {
          name: [
            { required: true, message: '请输入属性名称', trigger: 'blur' },
            { max: 50, message: '长度在 20 个字符以内', trigger: 'blur' }
          ],
          type: [
            { required: true, message: '请选择类型', trigger: 'change' }
          ],
          companyId: [
            { required: true, message: '请选择公司', trigger: 'change' }
          ]
        }
      }
    },
    computed: {
      ...mapGetters([
        'userInfo',
        'roles',
        'currentRoles'
      ])
    },
    created() {
      if (this.userInfo.companyList) {
        this.companyId = this.userInfo.companyList[0].id
        this._getList()
      }
    },
    activated() {},
    methods: {
      // 打开model
      openModel() {
        this.dialogVisible = true
        this.form = {
          name: '',
          type: '',
          values: '',
          remark: '',
          companyId: this.companyId
        }
        if (this.$refs['property']) {
          this.$refs['property'].resetFields()
        }
      },
      openModel2(row) {
        this.dialogVisible2 = true
        this.currentRow = row
        if (this.$refs['property2']) {
          this.$refs['property2'].resetFields()
        }
      },
      indexMethod(index) {
        return (this.pageIndex - 1) * 20 + index + 1
      },
      // 翻页
      pageChange(pageIndex) {
        this.pageIndex = pageIndex
        this._getList(pageIndex)
      },
      // 关闭对话框
      handleClose() {
        this.$confirm('确认关闭？').then(_ => {
          this.dialogVisible = false
          this.dialogVisible2 = false
        }).catch(_ => {})
      },
      // 搜索
      seach() {
        this.pageIndex = 1
        this._getList()
      },
      // 获取列表
      _getList(pageIndex = 1) {
        if (!this.companyId) return
        apiList(this.companyId, this.query, pageIndex).then(data => {
          this.list = data.data.data
          this.total = data.data.total
        })
      },
      // 新增
      handleAdd() {
        this.$refs['property'].validate((valid) => {
          if (valid) {
            apiEdit(this.form, this.form.companyId).then(() => {
              this.$message({
                type: 'success',
                message: '新增成功'
              })
              this.dialogVisible = false
              this._getList()
            })
          }
        })
      },
      // 编辑
      handleEdit() {
        this.$refs['property2'].validate((valid) => {
          if (valid) {
            apiEdit(this.currentRow, this.currentRow.companyId).then(() => {
              this.$message({
                type: 'success',
                message: '修改成功'
              })
              this.dialogVisible2 = false
              this._getList()
            })
          }
        })
      },
      // 删除
      handleDelete(row) {
        this.$confirm(`是否删除属性：${row.name}`, '提示', {
          confirmButtonText: '确认',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          apiDelete(row.id).then(() => {
            this.$message({
              type: 'success',
              message: '删除成功'
            })
            this._getList()
          })
        })
      }
    }
  }
</script>

<style lang="stylus">
  .page-index.property-index
    .el-form-item__content
      width 200px
    .btn-left
      background #A5CE1C
      color #fff
    .el-table
      .has-gutter
        th
          background #F5F7FA
          border-right 1px solid #EBEEF5
          border-top 1px solid #ebeef5
    .toolbar-box
      display flex
      margin 10px 0
      .search-input
        width 150px
        margin-right 10px
        .el-input__inner
          height 36px
          line-height 36px
      .select-box
        width 120px
        margin-right 10px
    .upload
      .el-upload
        width 100%
        .el-upload-dragger
          width 100%
</style>
